import { inject, Service } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ConfirmService } from './confirm.service';

@Service()
export class DirtyTrackingService {
    forms: FormTracking[] = [];

    private confirmService = inject(ConfirmService);

    constructor() {
    }

    private formCount = 0;

    registerForms(f: NgForm[]): number[] {
        var ids: number[] = [];
        f.forEach((x) => {
            var g = this.formCount++;
            ids.push(g);
            this.forms.push({ id: g, form: x });
        });
        return ids;
    }

    clearForms(ids: number[]): void {
        for (var idx = this.forms.length - 1; idx >= 0; idx--) {
            if (ids.indexOf(this.forms[idx].id) >= 0) {
                this.forms.splice(idx, 1);
            }
        }
    }

    isDirty(): boolean {
        if (!this.forms) {
            return false;
        }
        var dirty: boolean = false;
        this.forms.map(f => f.form).forEach(form => {
            dirty = dirty || form.dirty || false;
            Object.keys(form.controls).forEach(key => {
                dirty = dirty || form.controls[key].dirty;
            });
        })
        return dirty;
    }

    private areYouSurePrompt(): string | null {
        if (this.isDirty()) {
            return `You have unsaved changes. Are you sure you want to leave this page?`;
        }
        return null;
    }

    isClean(): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            var prompt = this.areYouSurePrompt();
            if (prompt) {
                this.confirmService.confirm(null, prompt).then(() => {
                    return resolve(true);
                }, () => {
                    return reject();
                });
            } else {
                return resolve(true);
            }
        });
    }
}

class FormTracking {
    id: number;
    form: NgForm;
}
